import React, {
	Suspense,
	useEffect,
	useLayoutEffect,
	useState,
	useTransition,
} from 'react';
import { Carousel, Col, Container, Row } from 'react-bootstrap';
import { useRecoilValue } from 'recoil';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Img } from 'react-suspense-img';
import { isMobile } from 'react-device-detect';
import { translatedText } from '../../recoil-states/language-state';
import '../../css/story.css';
import Header from '../../component/header';
import Footer from '../../component/Footer';
import { Fade } from 'react-awesome-reveal';
import ProfileTable from '../../component/Story/ProfileTable';

export default function Story({ windowWidth, handleAuth }) {
	const textData = useRecoilValue(translatedText);
	const [activedTab, setActivedTab] = useState(0);

	const carouselTabMenuList = ['STORY', 'DUMAN', 'KCT', 'Mystery Box'];

	function CarouselTabMenu({ name, activedTab, index }) {
		return (
			<li
				className={`story-carousel__tap-menu__item${
					activedTab === index ? ' active' : ''
				}`}
				onClick={() => {
					setActivedTab(index);
				}}
			>
				{name}
			</li>
			// </div>
		);
	}

	function ControlledCarousel({ activedTab }) {
		const [index, setIndex] = useState(0);

		const handleSelect = (selectedIndex, e) => {
			setIndex(selectedIndex);
		};

		const Icon = (direction, carouselLength) => {
			return (
				<span
					aria-hidden='true'
					className={`story-carousel__${direction}-icon`}
					style={{
						display: carouselLength === 1 ? 'none' : 'inline',
					}}
				/>
			);
		};

		const CarouselTextContent = ({ item }) => {
			return (
				<Col
					className='story-carousel__col-story-content-container'
					xxl={6}
					sm={12}
				>
					<Row className='story-carousel__phase-container'>
						<Col className='story-carousel__phase'>
							<p>{item.subPhase}</p>
							{windowWidth >= 1024 ? (
								<p>{item.phase}</p>
							) : (
								<p
									style={{
										marginLeft: 5,
									}}
								>
									{item.phase}
								</p>
							)}
							<div />
						</Col>
					</Row>
					<Row className='story-carousel__title-container'>
						<Col className='story-carousel__title'>
							<h1>{item.title}</h1>
							{item.subTitle && <h2>{item.subTitle}</h2>}
						</Col>
					</Row>
					<Row className='story-carousel__content-container'>
						<Col className='story-carousel__content'>
							<span>{item.content}</span>
							{item.profile && (
								<ProfileTable
									profile={item.profile}
									width={
										windowWidth >= 1024 ? '385px' : '100%'
									}
									marginTop={
										windowWidth >= 1024 ? '20px' : '50px'
									}
									textData={textData}
								/>
							)}
						</Col>
					</Row>
				</Col>
			);
		};

		const stories = [
			textData.story.carousel_story,
			textData.story.carousel_duman,
			textData.story.carousel_kct,
			textData.story.carousel_misteryBox,
		];

		return (
			<>
				<Carousel
					activeIndex={index}
					onSelect={handleSelect}
					indicators={
						stories[activedTab].length === 1 || windowWidth >= 1024
							? false
							: true
					}
					nextIcon={Icon('next', stories[activedTab].length)}
					prevIcon={Icon('prev', stories[activedTab].length)}
					interval={null}
				>
					{stories[activedTab].map((item, index) => (
						<Carousel.Item key={index}>
							<Row className='story-carousel__row-container'>
								{windowWidth >= 1024 && (
									<CarouselTextContent item={item} />
								)}
								<Col
									className='story-carousel__col-story-picture-container'
									xxl={6}
									sm={12}
								>
									<Suspense>
										<Img
											src={require(`../../assets/${item.img}`)}
											alt="story's image"
											onClick={() => {}}
										/>
									</Suspense>
								</Col>
							</Row>
						</Carousel.Item>
					))}
				</Carousel>
				{windowWidth < 1024 && (
					<CarouselTextContent item={stories[activedTab][index]} />
				)}
			</>
		);
	}

	return (
		<>
			<HelmetProvider>
				<Helmet>
					<link
						rel='stylesheet'
						type='text/css'
						href='./css/story_background.css'
					/>
				</Helmet>
			</HelmetProvider>
			<Container
				fluid
				id='story'
				style={{ paddingLeft: '0', paddingRight: '0' }}
			>
				<Header handleAuth={handleAuth} />
				<Row
					className='story-video__container'
					style={{ marginTop: isMobile ? '5rem' : null }}
				>
					<Col className='story_video'>
						<video
							controls
							webkit-playsinline='true'
							autoPlay
							playsInline={true}
							src={
								'https://s3.ap-northeast-2.amazonaws.com/asset.konnect-world.com/videos/intro.mp4'
							}
						/>
					</Col>
				</Row>
				<Row className='story-carousel__container'>
					<Row className='story-carousel__header__container'>
						<Col className='story-carousel__header'>
							<Fade clear>
								<h1>{textData.story.carousel_title_forward}</h1>
								<h1>
									{textData.story.carousel_title_backward}
								</h1>
							</Fade>
						</Col>
					</Row>
					<Fade clear>
						<Row className='story-carousel__tap-menu-bar'>
							<ul>
								{carouselTabMenuList.map((item, index) => (
									<CarouselTabMenu
										key={item}
										index={index}
										name={item}
										activedTab={activedTab}
									/>
								))}
							</ul>
						</Row>
					</Fade>
					<Fade>
						<Row className='story-carousel'>
							{<ControlledCarousel activedTab={activedTab} />}
						</Row>
					</Fade>
				</Row>
				<Footer backgroundColor='transparent' />
			</Container>
		</>
	);
}
